export default __webpack_public_path__ + "static/media/p-40.d78b1edd.svg";